import { validateStorage } from "./utils";

export function helpButton() {
	if (window.__helpButtonInitialized) return;
	const localStorageToken = localStorage.getItem('accessToken');
	const companyState=sessionStorage.getItem("companyState");
		if (validateStorage( localStorageToken) && companyState) {
			window.__helpButtonInitialized = true;
		const dataInfo = parseJwt(localStorageToken);
		const companyInfo=JSON.parse(companyState);
		ChatbotLoad(dataInfo,companyInfo);
		window.inlineManualTracking = {};
		window.inlineManualOptions = { language: 'en' };
		let domainInLine =
			window.location.hostname.split('.')[
			window.location.hostname.split('.').length - 2
			];

		let inlineID = {
			devctinube: '6b27d5a22b456d0bfcdd15bef4f87431',
			testdevcontpaqinube: '6b27d5a22b456d0bfcdd15bef4f87431',
			testcontpaqinube: '6b27d5a22b456d0bfcdd15bef4f87431',
			contpaqinube: '6a289377e195ad514f3cfc50d04a07c8',
		};

		const loaderId = inlineID[domainInLine] ?? inlineID.devctinube;

		!(function (e, n, a, t, i, r, s) {
			(e[i] =
				e[i] ||
				function () {
					(e[i].q = e[i].q || []).push(arguments);
				}),
				(e[i].l = 1 * new Date()),
				(e[i].snippet = {
					version: '2.0',
				}),
				(r = n.createElement(a)),
				(s = n.getElementsByTagName(a)[0]),
				(r.async = 1),
				(r.src = t),
				(r.id = t + '-' + i),
				s.parentNode.insertBefore(r, s);
		})(
			window,
			document,
			'script',
			`https://cdn.inlinemanual.com/inm/loader/loader.${loaderId}.js`,
			'InlineManual'
		);

		InlineManual('boot', {
			uid: dataInfo.email,
			email: dataInfo.email,
			username: dataInfo.email,
			name: dataInfo.given_name,
			product: 'colabora',
		});
	}
}

const ChatbotLoad = (dataInfo,companyInfo) => {
	const fullName =  `${dataInfo.given_name} ${dataInfo.family_name} ${dataInfo.extension_family_second_name}`;
	const prechatFields = {
		origen: window.REACT_APP_CHATBOT_ORIGEN,
		emailUser: dataInfo.email,
		userName: fullName,
		accountNumber: companyInfo.ownerLicenseCode,
		nivel: window.REACT_APP_CHATBOT_LEVEL,
		timestamp: new Date().toISOString(),
	};

	const baseUrl = `${document.location.protocol}${window.REACT_APP_CHATBOT_CHATBOTURL}`;
	const script = document.createElement('script');

	script.type = 'text/javascript';
	script.id = 'chat-script';
	script.src = `${baseUrl}/assets/js/bootstrap.min.js`;

	script.onload = () => {
		try {
			window.embeddedservice_bootstrap.settings.language = 'es_MX';
			embeddedservice_bootstrap.settings.chatButtonPosition = "30px,calc(100vw - 80px)";
			window.embeddedservice_bootstrap.init(
				window.REACT_APP_CHATBOT_ORGANIZATIONID,
				window.REACT_APP_CHATBOT_DEPLOYMENT_NAME,
				baseUrl,
				{ scrt2URL: document.location.protocol + window.REACT_APP_CHATBOT_SRCT2URL }
			);
			console.log('Chatbot: chatbot chat initialized successfully');
		} catch (e) {
			console.error('Chatbot: Error initializing chatbot chat:', e);
		}
	};

	document.body.appendChild(script);


	window.addEventListener('onEmbeddedMessagingReady', () => {
		window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields(prechatFields);
	});

}

const parseJwt = (localStorageToken) => {
	let base64Url = localStorageToken.split('.')[1];
	let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
	let jsonPayload = decodeURIComponent(
		window
			.atob(base64)
			.split('')
			.map(function (c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			})
			.join('')
	);
	return JSON.parse(jsonPayload);
}


export const getQueryVariable = (variable) => {
	const query = window.location.search.substring(1);
	const vars = query.replace('#state', '&state').split('&');

	if (vars.length > 1) {
		const p2 = vars[1];
		let localStorageToken = p2.split('=');

		localStorage.setItem('accessToken', localStorageToken[1]);
	}
	for (const vrItem of vars) {
		const pair = vrItem.split('=');

		if (pair[0] === variable) {
			return pair[1];
		}
	}
	return '';
};
